const weekLetters = [ "S", "T", "Q", "Q", "S", "S","D"];

export {weekLetters};